import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=65af85a3&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
import style0 from "./Nav.vue?vue&type=style&index=0&id=65af85a3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af85a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65af85a3')) {
      api.createRecord('65af85a3', component.options)
    } else {
      api.reload('65af85a3', component.options)
    }
    module.hot.accept("./Nav.vue?vue&type=template&id=65af85a3&scoped=true", function () {
      api.rerender('65af85a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Nav.vue"
export default component.exports